import { useEffect } from "react";
import { STORE_REDIRECTS, normalizePath } from "@/lib/storeRedirects";

// SPA fallback for the marketing redirect paths. The inline script in
// index.html normally handles these before the bundle loads; this covers
// client-side navigation and any case the script missed.
export default function StoreRedirect() {
  useEffect(() => {
    const url = STORE_REDIRECTS[normalizePath(window.location.pathname)];
    if (url) window.location.replace(url);
  }, []);

  return (
    <div
      data-testid="store-redirect"
      style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#fdfbf7", color: "#78716c", fontFamily: "Manrope, sans-serif" }}
    >
      Redirecting to the App Store…
    </div>
  );
}
